import React from 'react';

const Metadata: React.FC = () => {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Metadata</h1>
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">Metadata management will be implemented here.</p>
      </div>
    </div>
  );
};

export default Metadata; 